export const getSetExercises = /* GraphQL */ `
  query GetSet($id: ID!) {
    getSet(id: $id) {
    title
    id
    sequences,
    exercises {
      items {
        exercise {
          id
          color
          displayDuration
          displayOrder
          duration
          favourite
          headline
          how
          icon
          image
          search
          subtitle  
          target
          title
          type
          mediaType
          videoID
        }
      }
    }
  }
  }
`;


export const cListActivities = /* GraphQL */ `
  query ListActivities(
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        userID
        date
        duration
      }
      nextToken
    }
  }
`;


// This works - it is a copy of a working /queries/listSet which accepts a 'filter'. 
// it is a custom query because we want to return the related exercises
export const cListSetsAndExercises = /* GraphQL */ `
  query ListSets(
    $filter: ModelSetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        type
        description
        durations
        sequences
        owner
        setType
        exercises {
         items {
            createdAt
            exercise {
              id
              color
              duration
              title
              type
              image
              icon
              target
              how
            }
        }
        nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;


export const listSetExercises = /* GraphQL */ `
 query ListSetExercises {
  listSets {
    items {
      id
      title
      durations
      description
      sequences
      owner
      exercises {
        items {
          exercise {
            id
            color
            duration
            title
            type
            image
            target
            how
          }
        }
      }
    }
  }
}
`;

